import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _, { groupBy, isBuffer, orderBy } from "lodash";
import { Card, Row, Col, Form, HelpBlock, Button } from "react-bootstrap";

import { fetchGenericData } from "../../../../webservices/generic/genericDataWs";
import FuseCollapsiblePanel from "../../FuseCollapsiblePanel";
import FuseToolbar from "../../FuseToolbar";
import FuseInputBox from "../../inputFields/FuseInputBox";
import FuseForm from "../../FuseForm";

const initState = {
  isInEdit: true,
  isCollapsed: false,
  name: "",
  username: "",
  number: 200,
  number0: "sewe",
  gender: "M",
  selectedItems: ["Item 1"],
  date: new Date(), //"23/04/1999",
  selectValue: 1,
  handler: 3,
  handler0: "",
  password: "",
};

const clearedState = {
  name: "",
  username: "",
  number: "",
  number0: "",
  gender: "",
  selectedItems: [],
  date: "",
  selectValue: "",
  handler: "",
  handler0: "",
  password: "",
};

class TestPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = { ...initState };
  }

  testFormValidation = () => {
    const genderValues = [
      { key: 1, value: "M", label: "Male" },
      { key: 2, value: "F", label: "Female" },
      { key: 3, value: "O", label: "Other" },
    ];

    const itemValues = [
      { key: "Item 1", value: "Item 1" },
      { key: "Item 2", value: "Item 2" },
      { key: "Item 3", value: "Item 3" },
      { key: "Item 4", value: "Item 4" },
      { key: "Item 5", value: "Item 5" },
      { key: "Item 6", value: "Item 6" },
      { key: "Item 7", value: "Item 7" },
    ];

    return (
      <div>
        <FuseForm
          onSubmit={(e) => {
            console.log("Submitting");
          }}
        >
          <h3>Form Validation</h3>
          <Button variant="success" type="submit">
            Save
          </Button>
          <Button
            variant="danger"
            onClick={() => this.setState({ ...clearedState })}
          >
            Clear
          </Button>
          <Button
            variant="info"
            onClick={() => this.setState({ ...initState })}
          >
            Refresh
          </Button>
          <Button
            variant="secondary"
            onClick={() => this.setState({ isInEdit: !this.state.isInEdit })}
          >
            {this.state.isInEdit ? "Editing: Enabled" : "Editing: Disabled"}
          </Button>
          {/* <FuseInputBox
            id="Input1"
            type="text"
            placeholder="name"
            required={true}
            editable={this.state.isInEdit}
            value={this.state.name}
            maxLength={10}
            minLength={5}
            regExp="[a-zA-Z0-9]+"
            regExpMissmatchMessage="Only letter and number characters are allowed"
            onChange={(val) => this.setState({ ...this.state, name: val })}
          /> */}
          {/* <FuseInputBox
            type="Double"
            placeholder="Number Value ..."
            required={true}
            editable={this.state.isInEdit}
            value={this.state.number}
            onChange={(val) => this.setState({ ...this.state, number: val })}
          /> */}
          {/* <FuseInputBox
            type="password"
            placeholder="password ..."
            required={true}
            editable={this.state.isInEdit}
            value={this.state.password}
            onChange={(val) => this.setState({ ...this.state, password: val })}
          /> */}
          <FuseInputBox
            type="dropdown"
            placeholder="Select your Gender..."
            required={true}
            editable={this.state.isInEdit}
            isMulti={false}
            dropDownValues={genderValues}
            dropKeyColumn="value"
            dropValueColumn="label"
            value={this.state.gender}
            onChange={(val) => this.setState({ ...this.state, gender: val })}
          />
          {/* <FuseInputBox
            type="dropdown"
            placeholder="Select a list of items..."
            required={true}
            editable={this.state.isInEdit}
            isMulti={true}
            dropDownValues={itemValues}
            dropKeyColumn="key"
            dropValueColumn="value"
            value={this.state.selectedItems}
            onChange={(val) =>
              this.setState({ ...this.state, selectedItems: val })
            }
          /> */}
          <FuseInputBox
            type="list_of_values"
            placeholder="Select a Handler..."
            lovTable="fuse_bus_rules_handler_tab"
            lovKeyColumn="id"
            lovValueColumn="name"
            editable={this.state.isInEdit}
            required={true}
            value={this.state.handler + ""}
            onChange={(val) => this.setState({ ...this.state, handler: val })}
          />
          {/* <FuseInputBox
            type="list_of_values"
            placeholder="Select a Handler..."
            lovTable="fuse_bus_rules_handler_tab"
            lovKeyColumn="id"
            lovValueColumn="name"
            editable={this.state.isInEdit}
            required={true}
            value={this.state.handler0 + ""}
            onChange={(val) => this.setState({ ...this.state, handler0: val })}
          /> */}
          {/* <FuseInputBox
            id="test-date"
            type="DateTime"
            editable={this.state.isInEdit}
            required={true}
            value={this.state.date}
            dateFormat={"dd/MM/yyyy"}
            placeholder={"Date of Birth"}
            onChange={(val) => this.setState({ ...this.state, date: val })}
          /> */}
        </FuseForm>
      </div>
    );
  };

  render() {
    return (
      <FuseCollapsiblePanel title="Test Panel">
        {this.testFormValidation()}
      </FuseCollapsiblePanel>
    );
  }
}

TestPanel.propTypes = {
  //fetchScreenInfo: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => {
  return {
    fetchingData: state.fetchingData === true,
    auth: state.auth,
    screenInfo: state.screenInfo,
  };
};

export default connect(
  // map state to props
  mapStateToProps,
  // map dispatch to props
  (dispatch, ownProps) => ({})
)(TestPanel);
